const upgradePersonal = {
  bannerTitle: 'HitPaw Онлайн Ultimate',
  introduct:
    'Получите премиальные преимущества для более чем 35 функций, включая Enhancers, Removers, AI Translators, Screen Recorders и многое другое. Получите все это по одной доступной цене.',
  Upgrade: 'Обновить',
  Tools: 'Инструменты',
  MyProjects: 'Мои проекты',
  MyAccount: 'Мой счет',
  Subscription: 'Подписка',
  LogOut: 'Выйти',
  PopularTools: 'Популярные инструменты',
  Enhance: 'Усиливать',
  Remove: 'Удалять',
  Animate: 'Анимировать',
  Extract: 'Извлекать',
  SaveThreeDays:
    'Проекты хранятся 3 дня, пожалуйста, скачайте их после обработки.',
  All: 'Все',
  Video: 'видео',
  Image: 'Изображение',
  Audio: 'Аудио',
  minutesAgo: 'минут назад',
  hoursAgo: 'несколько часов назад',
  daysAgo: 'дней назад',
  Modified: 'Изменено',
  Order: 'Заказ',
  EarliestToLatest: 'От раннего к последнему',
  LatestToEarliest: 'От последнего к самому раннему',
  NoProject: 'Пока нет проекта. Быстрый старт с',
  OnlineTools: 'Онлайн-инструменты',
  AIVideoEnhancer: 'ИИ-улучшитель видео',
  Enhancer4K: 'Один щелчок, чтобы AI улучшал видео до 4K онлайн',
  AIPhotoEnhancer: 'ИИ-улучшитель фотографий',
  AIEnhancerImage: 'ИИ улучшает изображения без потерь до 8 раз онлайн',
  View: 'Вид',
  Download: 'Скачать',
  MultipleSelect: 'Множественный выбор',
  Delete: 'Удалить',
  SubscriptionHistory: 'История подписки',
  NoValidSubscription: 'Нет действующей подписки.',
  veContent: 'Один щелчок, чтобы AI улучшал видео до 4K онлайн',
  peContent: 'ИИ улучшает изображения без потерь до 8 раз онлайн',
  rmvContent: 'Удалить водяной знак с видео',
  rmttContent: 'Удалите водяные знаки TikTok с видео в мгновение ока',
  dynamicContent: 'Анимируйте свою фотографию онлайн',
  rmbgContent: 'Удалить фон с изображения',
  youMayNeed: 'Вам может понадобиться',
  new: 'Новый',
  rather: 'Я бы заплатил полную цену по цене $ 4,49 в месяц.',
  loginYourAccount: 'Войдите в свою учетную запись HitPaw',
  signUpYourAccount: 'Зарегистрируйтесь в своей учетной записи HitPaw',
  HitPawWatermark: 'Watermark Remover',
  HitPawTiktokWatermark: 'TikTok Watermark Remover',
  HitPawRemoveBg: 'Background Remover',
  dynamicTitle: 'HitPaw Online Animate Old Photos',
};
export default upgradePersonal;
